export const GERMAN_DATE_FORMAT = 'dd.MM.yyyy';
export const FRENCH_DATE_FORMAT = 'dd/MM/yyyy';
export const ENGLISH_DATE_FORMAT = 'MM/dd/yyyy';
